// src/components/Step2/Step2.jsx
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import CheckIcon from '@material-ui/icons/Check'
import styles from './styles.module.css'
import { useLocation } from 'react-router-dom'
import DatafinitiLogo from '../../HomeDR12/images/datafiniti-logo-white.svg'
import useAlerts from '../../Snackbar/NewImplementations/HooksAlerts/useAlerts'
import ColorAlert from '../../Snackbar/NewImplementations/ColorAlert/ColorAlert'

function Step2 ({ onNext, isActive }) {
  const {
    register,
    handleSubmit,
    setValue
  } = useForm({
    mode: 'onChange'
  })
  const location = useLocation()
  const [isDataSaved, setIsDataSaved] = useState(false)
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')

  // Use the shared alerts hook
  const { alerts, closeAlert, showValidationErrors, pushAlert } = useAlerts()

  useEffect(() => {
    const savedData = localStorage.getItem('dfp/step2_data')
    if (savedData && token) {
      const parsedData = JSON.parse(savedData)
      setValue('firstName', parsedData.firstName)
      setValue('lastName', parsedData.lastName)
      setValue('organization', parsedData.organization)
      setValue('password', parsedData.password)
      setIsDataSaved(true)
    }
  }, [setValue, token, pushAlert])

  const onSubmit = data => {
    localStorage.setItem('dfp/step2_data', JSON.stringify(data))
    setIsDataSaved(true)
    onNext()
  }

  return (
    <section className={styles.section}>
      <img
        src={DatafinitiLogo}
        alt='DatafinitiLogo'
        className={styles.logo}
        style={{ opacity: isActive ? 1 : 0 }}
      />
      <div>
        <h1 className={styles.heading}>Step 2: Account Information</h1>
        <span className={styles.subheading}>
          Provide account information and password.
        </span>
        <div>
          <form
            autoComplete='off'
            className={styles.form}
            onSubmit={handleSubmit(onSubmit, showValidationErrors)}
          >
            <input
              autoFocus
              type='text'
              placeholder='First name'
              className={styles.inputStep2}
              disabled={!isActive || isDataSaved}
              autoComplete='off'
              {...register('firstName', { required: 'First name is required' })}
            />

            <input
              type='text'
              placeholder='Last name'
              className={styles.inputStep2}
              disabled={!isActive || isDataSaved}
              autoComplete='off'
              {...register('lastName', { required: 'Last name is required' })}
            />

            <input
              type='text'
              id='organization-field'
              name='organization'
              placeholder='Organization'
              className={styles.inputStep2}
              disabled={!isActive || isDataSaved}
              autoComplete='off'
              {...register('organization', {
                required: 'Organization is required'
              })}
            />

            <input
              type='password'
              placeholder='Password'
              className={styles.inputStep2}
              disabled={!isActive || isDataSaved}
              autoComplete='off'
              {...register('password', {
                required: 'Password is required',
                minLength: {
                  value: 8,
                  // message: 'Password must be at least 8 characters long'
                  message: 'Password is too short'
                }
              })}
            />

            <button
              className={`${
                styles.buttonStep2
              } ${
                isDataSaved
                  ? styles.buttonSuccess
                  : isActive
                  ? styles.buttonEnabled
                  : styles.buttonDisabled
              }`}
              // disabled={!isValid || !isActive || isDataSaved}
              disabled={!isActive}
            >
              {isDataSaved ? (
                <CheckIcon className={styles.iconInsideButton} />
              ) : (
                'Continue'
              )}
            </button>
          </form>
          {/* Render stacked validation alerts at bottom-center */}

          {alerts.slice(-3).map((alert, i) => (
            <ColorAlert
              key={alert.id}
              open={alert.open}
              type={alert.type}
              label={alert.message}
              onClose={() => closeAlert(alert.id)}
              style={{
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                top: `calc(126.1% - ${20 + i * 80}px)`
              }}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Step2
